export default __webpack_public_path__ + "static/banner-the-perfect-experience-for-every-stage-of-your-relationship-b2d24e197b1384dbca874f3696edd158.jpg";